/*
 * Approval process: from "In Progress" onward an order is locked. Its edit
 * action becomes a "Change Request" — the same form, submitted for approval.
 * Must match LOCKED_ORDER_STATUSES / CHANGE_REQUEST_ORDER_STATUSES in
 * backend/constants/changeRequest.js.
 */
export const ORDER_LOCKED_STATUSES = ["IN PROGRESS", "DELIVERED", "PAID_CLOSED", "LOST_CANCELLED"];
export const ORDER_CHANGE_REQUEST_STATUSES = ["IN PROGRESS", "DELIVERED", "PAID_CLOSED"];

/*
 * Super admins and the two fixed approvers (sales@ / finance@) edit a locked
 * order straight away, so they keep the normal Edit action. The flag is set
 * once per session by useOrderChangeAccess() — the listings call the helpers
 * below for every row, so it cannot be a per-row lookup.
 */
let directEditAllowed = false;

export const setDirectEditAllowed = (value) => {
  directEditAllowed = Boolean(value);
};

export const canEditLockedOrders = () => directEditAllowed;

export const isOrderLocked = (status) => ORDER_LOCKED_STATUSES.includes(status);

/** True when this user has to go through a change request for that order. */
export const canRequestOrderChange = (status) =>
  !directEditAllowed && ORDER_CHANGE_REQUEST_STATUSES.includes(status);

/* Lost/Cancelled orders are read-only: no edit and no change request. */
export const isOrderReadOnly = (status) =>
  isOrderLocked(status) && !ORDER_CHANGE_REQUEST_STATUSES.includes(status);
